import React from 'react'; // Import React core library
import ReactDOM from 'react-dom/client'; // Import ReactDOM for rendering the app
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter for client-side routing
import App from './App'; // Import the main App component
import ErrorBoundary from './components/common/home/ErrorBoundary.tsx'; // Import ErrorBoundary to catch runtime errors
import { AuthProvider } from './context/AuthContext.tsx'; // Import AuthProvider to provide authentication context to the app
import './assets/styles/tailwind.css'; // Import Tailwind CSS styles
import axios from 'axios'; // Import axios for HTTP requests

// Configure axios to always send cookies with requests (important for session-based auth)
axios.defaults.withCredentials = true;

// Get the root DOM element to mount the React app
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Render the React app into the DOM
root.render(
  <React.StrictMode> {/* Enable additional checks and warnings in development */}
    <ErrorBoundary> {/* Wrap the app in an error boundary to catch unexpected runtime errors */}
      <AuthProvider> {/* Provide authentication state and functions to all child components */}
        <BrowserRouter> {/* Enable React Router for client-side navigation */}
          <App /> {/* Render the main App component containing all routes */}
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
